import { render } from "./Cargador-recursos.vue?vue&type=template&id=57bc91ee&scoped=true"
import script from "./Cargador-recursos.vue?vue&type=script&lang=js"
export * from "./Cargador-recursos.vue?vue&type=script&lang=js"

import "./Cargador-recursos.vue?vue&type=style&index=0&id=57bc91ee&lang=scss&scoped=true"

import exportComponent from "C:\\Development\\PircaGIT\\PircaSolutions.Forge.LMS\\PircaSolutions.Forge.LMS.Site.UI\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57bc91ee"]])

export default __exports__